import { render } from "./ButtonOpenFilter.vue?vue&type=template&id=47824867&ts=true"
import script from "./ButtonOpenFilter.vue?vue&type=script&lang=ts"
export * from "./ButtonOpenFilter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__